import { Component } from 'react'
import { Box, Link, Heading } from 'theme-ui'

import emoji from 'react-easy-emoji'

class Header extends Component {
  render() {
    return (
      <Box sx={{ mt: [3, null, 4] }}>
        <Heading as="h3" sx={{ fontSize: [4], lineHeight: 'body', my: [2, null, 3] }}>
          Willkommen !
        </Heading>
        <Box sx={{ mb: [2, null, 3], maxWidth: ['100%', '100%', '30em'] }}>
          Polis is built for the public with {emoji('❤️')} in Seattle with contributions from around the {emoji('🌍🌏🌎')}
        </Box>
        <Box sx={{ mb: [2, null, 3] }}>
          Based on request of AG Richtlinien member, local instance of Pol.Is software has been deployed & adapted for needs of (not only) UdK AI Sounding Board in February 2026 by ddh@<a href="https://udk.ai">udk.ai</a> with support from GenKI-Lab. 
        </Box>
        <div id="polis-donate">
          <i>
            <br/>Conversation <a href="https://polis.udk.digital/4tesxwtfub">"Nachhaltige KI"</a> is active since 22.2.2026. 
            <br/>Conversation <a href="https://polis.udk.digital/2dmtb6annv">"KI an der UdK -- Wie und wo wollen wir sie einsetzen?"</a> is active since 14.4.2026. 
          </i>
	    <br/><br/><b/>No cloud, no AWS, no snake-oil. Pure Medienhaus.
        </div>
      </Box>
    )
  }
}

export default Header
